export default __webpack_public_path__ + "static/media/sponsor_toyota_dark.08a9dc04.svg";